// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pvtUi {
  color: #000000;
  font-family: Verdana;
  border-collapse: collapse;
}

.pvtUi select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}

.pvtUi td.pvtOutput {
  vertical-align: top;
}

table.pvtTable {
  font-size: 8pt;
  text-align: left;
  border-collapse: collapse;
  margin-top: 3px;
  margin-left: 3px;
  font-family: Verdana;
}

table.pvtTable thead tr th,
table.pvtTable tbody tr th {
  background-color: #f4f4f4;
  border: 1px solid #cacaca;
  font-size: 8pt;
  padding: 5px;
}

table.pvtTable .pvtColLabel {
  text-align: center;
}

table.pvtTable .pvtTotalLabel {
  text-align: right;
}

table.pvtTable tbody tr td {
  color: #2a3f5f;
  padding: 5px;
  background-color: #fff;
  border: 1px solid #c8d4e3;
  vertical-align: top;
  text-align: right;
}

.pvtTotal,
.pvtGrandTotal {
  font-weight: bold;
}

.pvtRowOrder,
.pvtColOrder {
  cursor: pointer;
  width: 15px;
  margin-left: 5px;
  display: inline-block;
  user-select: none;
  text-decoration: none !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}

.pvtAxisContainer,
.pvtVals {
  border: 1px solid #cacaca;
/*   background: #f4f4f4; */
  padding: 5px;
  min-width: 20px;
  min-height: 20px;
}

.pvtRenderers {
  padding-left: 5px;
  user-select: none;
}

.pvtDropdown {
  display: inline-block;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 3px;
}

.pvtDropdownIcon {
  float: right;
  color: #a2b1c6;
}

.pvtDropdownCurrent {
  text-align: left;
  border: 1px solid #a2b1c6;
  border-radius: 4px;
  display: inline-block;
  position: relative;
  width: 210px;
  box-sizing: border-box;
  background: white;
}

.pvtDropdownCurrentOpen {
  border-radius: 4px 4px 0 0;
}

.pvtDropdownMenu {
  background: white;
  position: absolute;
  width: 100%;
  margin-top: -1px;
  border-radius: 0 0 4px 4px;
  border: 1px solid #a2b1c6;
  border-top: 1px solid #dfe8f3;
  box-sizing: border-box;
}

.pvtDropdownValue {
  padding: 2px 5px;
  font-size: 12px;
  text-align: left;
}

.pvtDropdownActiveValue {
  background: #ebf0f8;
}

.pvtVals {
  text-align: center;
  white-space: nowrap;
  vertical-align: top;
  padding-bottom: 12px;
}

.pvtRows {
  height: 35px;
}

.pvtAxisContainer li {
  padding: 8px 6px;
  list-style-type: none;
  cursor: move;
}

.pvtAxisContainer li.pvtPlaceholder {
  -webkit-border-radius: 5px;
  padding: 3px 15px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 1px dashed #a2b1c6;
}

.pvtAxisContainer li.pvtPlaceholder span.pvtAttr {
  display: none;
}

.pvtAxisContainer li span.pvtAttr {
  -webkit-text-size-adjust: 100%;
  background: #f4f4f4;
  border: 1px solid #cacaca;
  padding: 2px 5px;
  white-space: nowrap;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}

.pvtTriangle {
  cursor: pointer;
  color: #506784;
}

.pvtHorizList li {
  display: inline-block;
}

.pvtVertList {
  vertical-align: top;
}

.pvtFilteredAttribute {
  font-style: italic;
}

.sortable-chosen .pvtFilterBox {
  display: none !important;
}

.pvtCloseX {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 18px;
  cursor: pointer;
  text-decoration: none !important;
}

.pvtDragHandle {
  position: absolute;
  left: 5px;
  top: 5px;
  font-size: 18px;
  cursor: move;
  color: #a2b1c6;
}

.pvtButton {
  color: #00496c;
  border-radius: 5px;
  padding: 3px 6px;
  background: #f4f4f4;
  border: 1px solid;
  border-color: #00496c;
  font-size: 14px;
  margin: 3px;
  transition: 0.34s all cubic-bezier(0.19, 1, 0.22, 1);
  text-decoration: none !important;
}

.pvtButton:hover {
  background: #e2e8f0;
  border-color: #a2b1c6;
}

.pvtButton:active {
  background: #d1dae6;
}

.pvtFilterBox input {
  border: 1px solid #c8d4e3;
  border-radius: 5px;
  color: #506784;
  padding: 0 3px;
  font-size: 14px;
}

.pvtFilterBox input:focus {
  border-color: #119dff;
  outline: none;
}

.pvtFilterBox {
  z-index: 100;
  width: 300px;
  border: 1px solid #506784;
  background-color: #fff;
  position: absolute;
  text-align: center;
  user-select: none;
  min-height: 100px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}

.pvtFilterBox h4 {
  margin: 15px;
}

.pvtFilterBox p {
  margin: 10px auto;
}

.pvtFilterBox button {
  color: #2a3f5f;
}

.pvtFilterBox input[type="text"] {
  width: 230px;
  color: #2a3f5f;
  margin-bottom: 5px;
}

.pvtCheckContainer {
  text-align: left;
  font-size: 14px;
  white-space: nowrap;
  overflow-y: scroll;
  width: 100%;
  max-height: 30vh;
  border-top: 1px solid #dfe8f3;
}

.pvtCheckContainer p {
  margin: 0;
  margin-bottom: 1px;
  padding: 3px;
  cursor: default;
}

.pvtCheckContainer p.selected {
  background: #f4f4f4;
}

.pvtOnly {
  display: none;
  width: 35px;
  float: left;
  font-size: 12px;
  padding-left: 5px;
  cursor: pointer;
}

.pvtOnlySpacer {
  display: block;
  width: 35px;
  float: left;
}

.pvtCheckContainer p:hover .pvtOnly {
  display: block;
}

.pvtCheckContainer p:hover .pvtOnlySpacer {
  display: none;
}

.pvtRendererArea {
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./../../custom/react-pivottable/pivottable.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B,2BAA2B;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,oDAAoD;EACpD,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd","sourcesContent":[".pvtUi {\r\n  color: #000000;\r\n  font-family: Verdana;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.pvtUi select {\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n.pvtUi td.pvtOutput {\r\n  vertical-align: top;\r\n}\r\n\r\ntable.pvtTable {\r\n  font-size: 8pt;\r\n  text-align: left;\r\n  border-collapse: collapse;\r\n  margin-top: 3px;\r\n  margin-left: 3px;\r\n  font-family: Verdana;\r\n}\r\n\r\ntable.pvtTable thead tr th,\r\ntable.pvtTable tbody tr th {\r\n  background-color: #f4f4f4;\r\n  border: 1px solid #cacaca;\r\n  font-size: 8pt;\r\n  padding: 5px;\r\n}\r\n\r\ntable.pvtTable .pvtColLabel {\r\n  text-align: center;\r\n}\r\n\r\ntable.pvtTable .pvtTotalLabel {\r\n  text-align: right;\r\n}\r\n\r\ntable.pvtTable tbody tr td {\r\n  color: #2a3f5f;\r\n  padding: 5px;\r\n  background-color: #fff;\r\n  border: 1px solid #c8d4e3;\r\n  vertical-align: top;\r\n  text-align: right;\r\n}\r\n\r\n.pvtTotal,\r\n.pvtGrandTotal {\r\n  font-weight: bold;\r\n}\r\n\r\n.pvtRowOrder,\r\n.pvtColOrder {\r\n  cursor: pointer;\r\n  width: 15px;\r\n  margin-left: 5px;\r\n  display: inline-block;\r\n  user-select: none;\r\n  text-decoration: none !important;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n.pvtAxisContainer,\r\n.pvtVals {\r\n  border: 1px solid #cacaca;\r\n/*   background: #f4f4f4; */\r\n  padding: 5px;\r\n  min-width: 20px;\r\n  min-height: 20px;\r\n}\r\n\r\n.pvtRenderers {\r\n  padding-left: 5px;\r\n  user-select: none;\r\n}\r\n\r\n.pvtDropdown {\r\n  display: inline-block;\r\n  position: relative;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  margin: 3px;\r\n}\r\n\r\n.pvtDropdownIcon {\r\n  float: right;\r\n  color: #a2b1c6;\r\n}\r\n\r\n.pvtDropdownCurrent {\r\n  text-align: left;\r\n  border: 1px solid #a2b1c6;\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 210px;\r\n  box-sizing: border-box;\r\n  background: white;\r\n}\r\n\r\n.pvtDropdownCurrentOpen {\r\n  border-radius: 4px 4px 0 0;\r\n}\r\n\r\n.pvtDropdownMenu {\r\n  background: white;\r\n  position: absolute;\r\n  width: 100%;\r\n  margin-top: -1px;\r\n  border-radius: 0 0 4px 4px;\r\n  border: 1px solid #a2b1c6;\r\n  border-top: 1px solid #dfe8f3;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.pvtDropdownValue {\r\n  padding: 2px 5px;\r\n  font-size: 12px;\r\n  text-align: left;\r\n}\r\n\r\n.pvtDropdownActiveValue {\r\n  background: #ebf0f8;\r\n}\r\n\r\n.pvtVals {\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: top;\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.pvtRows {\r\n  height: 35px;\r\n}\r\n\r\n.pvtAxisContainer li {\r\n  padding: 8px 6px;\r\n  list-style-type: none;\r\n  cursor: move;\r\n}\r\n\r\n.pvtAxisContainer li.pvtPlaceholder {\r\n  -webkit-border-radius: 5px;\r\n  padding: 3px 15px;\r\n  -moz-border-radius: 5px;\r\n  border-radius: 5px;\r\n  border: 1px dashed #a2b1c6;\r\n}\r\n\r\n.pvtAxisContainer li.pvtPlaceholder span.pvtAttr {\r\n  display: none;\r\n}\r\n\r\n.pvtAxisContainer li span.pvtAttr {\r\n  -webkit-text-size-adjust: 100%;\r\n  background: #f4f4f4;\r\n  border: 1px solid #cacaca;\r\n  padding: 2px 5px;\r\n  white-space: nowrap;\r\n  -webkit-border-radius: 5px;\r\n  -moz-border-radius: 5px;\r\n  border-radius: 5px;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n.pvtTriangle {\r\n  cursor: pointer;\r\n  color: #506784;\r\n}\r\n\r\n.pvtHorizList li {\r\n  display: inline-block;\r\n}\r\n\r\n.pvtVertList {\r\n  vertical-align: top;\r\n}\r\n\r\n.pvtFilteredAttribute {\r\n  font-style: italic;\r\n}\r\n\r\n.sortable-chosen .pvtFilterBox {\r\n  display: none !important;\r\n}\r\n\r\n.pvtCloseX {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 5px;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  text-decoration: none !important;\r\n}\r\n\r\n.pvtDragHandle {\r\n  position: absolute;\r\n  left: 5px;\r\n  top: 5px;\r\n  font-size: 18px;\r\n  cursor: move;\r\n  color: #a2b1c6;\r\n}\r\n\r\n.pvtButton {\r\n  color: #00496c;\r\n  border-radius: 5px;\r\n  padding: 3px 6px;\r\n  background: #f4f4f4;\r\n  border: 1px solid;\r\n  border-color: #00496c;\r\n  font-size: 14px;\r\n  margin: 3px;\r\n  transition: 0.34s all cubic-bezier(0.19, 1, 0.22, 1);\r\n  text-decoration: none !important;\r\n}\r\n\r\n.pvtButton:hover {\r\n  background: #e2e8f0;\r\n  border-color: #a2b1c6;\r\n}\r\n\r\n.pvtButton:active {\r\n  background: #d1dae6;\r\n}\r\n\r\n.pvtFilterBox input {\r\n  border: 1px solid #c8d4e3;\r\n  border-radius: 5px;\r\n  color: #506784;\r\n  padding: 0 3px;\r\n  font-size: 14px;\r\n}\r\n\r\n.pvtFilterBox input:focus {\r\n  border-color: #119dff;\r\n  outline: none;\r\n}\r\n\r\n.pvtFilterBox {\r\n  z-index: 100;\r\n  width: 300px;\r\n  border: 1px solid #506784;\r\n  background-color: #fff;\r\n  position: absolute;\r\n  text-align: center;\r\n  user-select: none;\r\n  min-height: 100px;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n.pvtFilterBox h4 {\r\n  margin: 15px;\r\n}\r\n\r\n.pvtFilterBox p {\r\n  margin: 10px auto;\r\n}\r\n\r\n.pvtFilterBox button {\r\n  color: #2a3f5f;\r\n}\r\n\r\n.pvtFilterBox input[type=\"text\"] {\r\n  width: 230px;\r\n  color: #2a3f5f;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.pvtCheckContainer {\r\n  text-align: left;\r\n  font-size: 14px;\r\n  white-space: nowrap;\r\n  overflow-y: scroll;\r\n  width: 100%;\r\n  max-height: 30vh;\r\n  border-top: 1px solid #dfe8f3;\r\n}\r\n\r\n.pvtCheckContainer p {\r\n  margin: 0;\r\n  margin-bottom: 1px;\r\n  padding: 3px;\r\n  cursor: default;\r\n}\r\n\r\n.pvtCheckContainer p.selected {\r\n  background: #f4f4f4;\r\n}\r\n\r\n.pvtOnly {\r\n  display: none;\r\n  width: 35px;\r\n  float: left;\r\n  font-size: 12px;\r\n  padding-left: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.pvtOnlySpacer {\r\n  display: block;\r\n  width: 35px;\r\n  float: left;\r\n}\r\n\r\n.pvtCheckContainer p:hover .pvtOnly {\r\n  display: block;\r\n}\r\n\r\n.pvtCheckContainer p:hover .pvtOnlySpacer {\r\n  display: none;\r\n}\r\n\r\n.pvtRendererArea {\r\n  padding: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
